<div id="change-reservation-details" uk-modal>
    <div class="uk-modal-dialog">
        <a class="uk-modal-close-default">
            <img src="../../../../assets/icons/Close.svg" height="32px" width="32px">
        </a>
        <div class="uk-modal-body" *ngIf="available === false && loading === false">
            <div class="uk-display-inline-block research-form-controls uk-width-1-1 uk-margin-remove">
                <h2 class="main-title bold color-grey uk-text-uppercase">
                    Changer les détails de la réservation
                </h2>
                <label class="uk-form-label uk-display-inline-block vop-blue uk-text-bold uk-margin-small-top uk-margin-small-bottom">
                    Indisponible pour le moment, veuillez réessayer ultérieurement.
                </label>
            </div>
            <div class="uk-width-1-1" *ngIf="loading">
                <span class="uk-display-block">
                    <div uk-spinner style="width: 18px;"></div>
                    <span class="uk-margin-small-left">Calcul de la période estimée</span>
                </span>
                <span class="uk-display-block uk-margin-small-top">
                    <div uk-spinner style="width: 18px;"></div>
                    <span class="uk-margin-small-left">Calcul du kilométrage estimée</span>
                </span>
            </div>
        </div>
        <div class="uk-modal-body" *ngIf="available === true">
            <title class="uk-modal-title color-grey">Changer les détails de la réservation</title>
            <div class="uk-display-inline-block research-form-controls uk-width-1-1 uk-margin-remove">
                <h2 class="main-title bold color-grey uk-text-uppercase">
                    Changer les détails de la réservation
                </h2>
                <div class="uk-form-stacked">
                    <div class="uk-margin">
                        <label class="label">Date de début réelle</label>
                        <div class="uk-form-controls uk-margin-small-top">
                            <div uk-grid class="remove-grid-ml-pl">
                                <div class="input alt color-cold-grey datepicker-bold uk-width-expand uk-display-inline-block">
                                    <app-datepicker [(date)]="dateStart"></app-datepicker>
                                </div>
                                <div class="uk-width-5-12 uk-position-relative">
                                    <span class="vertical-align uk-margin-left">à</span>
                                    <input class="input alt color-cold-grey bold uk-width-1-1 uk-margin-left" [(ngModel)]="hourStart" type="number" style="padding: 4px; width: 50px;">
                                    <span class="vertical-align uk-margin-left">h</span>
                                    <input class="input alt color-cold-grey bold uk-width-1-1 uk-margin-left" [(ngModel)]="minuteStart" type="number" style="padding: 4px; width: 50px;">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="uk-margin">
                        <label class="label">Date de fin réelle</label>
                        <div class="uk-form-controls uk-margin-small-top">
                            <div uk-grid class="remove-grid-ml-pl">
                                <div class="input alt color-cold-grey datepicker-bold uk-width-expand uk-display-inline-block">
                                    <app-datepicker [(date)]="dateEnd"></app-datepicker>
                                </div>
                                <div class="uk-width-5-12 uk-position-relative">
                                    <span class="vertical-align uk-margin-left">à</span>
                                    <input class="input alt color-cold-grey bold uk-width-1-1 uk-margin-left" [(ngModel)]="hourEnd" type="number" style="padding: 4px; width: 50px;">
                                    <span class="vertical-align uk-margin-left">h</span>
                                    <input class="input alt color-cold-grey bold uk-width-1-1 uk-margin-left" [(ngModel)]="minuteEnd" type="number" style="padding: 4px; width: 50px;">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="uk-margin">
                        <label class="label">Kilométrage réel</label>
                        <div class="uk-form-controls uk-margin-small-top">
                            <input [(ngModel)]="km" class="input alt color-cold-grey bold uk-width-1-1" type="number">
                        </div>
                    </div>
                </div>
            </div>
            <div uk-grid class="remove-grid-ml-pl uk-grid-small modal-gray-part">
                <div class="reload-details" (click)="loadEstimations()">
                    <span class="material-icons vertical-align-middle">cached</span>
                    <span class="vertical-align-middle" style="margin-left: 5px;">Recharger</span>
                </div>
                <div class="uk-width-1-1" *ngIf="loadingEstimation === true">
                    <span class="uk-display-block">
                        <div uk-spinner style="width: 18px;"></div>
                        <span class="uk-margin-small-left">Calcul de la période estimée</span>
                    </span>
                    <span class="uk-display-block uk-margin-small-top">
                        <div uk-spinner style="width: 18px;"></div>
                        <span class="uk-margin-small-left">Calcul du kilométrage estimée</span>
                    </span>
                </div>
                <div class="uk-width-1-2 uk-margin-medium-top" *ngIf="loadingEstimation === false">
                    <div class="uk-margin-small-left uk-margin-small-bottom">Période réelle estimée</div>
                    <div *ngIf="estimatedPeriod.ISOEstimatedRealStartDate.includes('1970-01-01') === false && estimatedPeriod.ISOEstimatedRealStartDate.includes('1970-01-01') === false">
                        <span class="bold uk-margin-small-left uk-display-block" humanDateFormat="{{ estimatedPeriod.ISOEstimatedRealStartDate }}"></span>
                        <span class="bold uk-margin-small-left uk-display-block" humanDateFormat="{{ estimatedPeriod.ISOEstimatedRealEndDate }}"></span>
                    </div>
                    <div *ngIf="estimatedPeriod.ISOEstimatedRealStartDate.includes('1970-01-01') === true && estimatedPeriod.ISOEstimatedRealStartDate.includes('1970-01-01') === true">
                        <span class="bold uk-margin-small-left uk-display-block" humanDateFormat="{{ reservation.ISODateStart }}"></span>
                        <span class="bold uk-margin-small-left uk-display-block" humanDateFormat="{{ reservation.ISODateEnd }}"></span>
                    </div>
                </div>
                <div class="uk-width-1-2 uk-margin-medium-top" *ngIf="loadingEstimation === false">
                    <div class="uk-margin-small-left uk-margin-small-bottom">Kilométrage réel estimé</div>
                    <span class="bold uk-margin-small-left uk-display-block">{{ estimatedKm }} km</span>
                </div>
            </div>
        </div>
        <div class="uk-modal-footer">
            <p class="uk-text-right">
                <button class="button bold uk-modal-close" type="button">Annuler</button>
                <button [attr.disabled]="available === false ? true : null" class="button bold uk-margin-small-left" (click)="updateCheckout()">Sauvegarder</button>
            </p>
        </div>
    </div>
</div>